import { render, staticRenderFns } from "./Denounces.vue?vue&type=template&id=3d6d406b&scoped=true&"
import script from "./Denounces.vue?vue&type=script&lang=ts&"
export * from "./Denounces.vue?vue&type=script&lang=ts&"
import style0 from "./Denounces.vue?vue&type=style&index=0&id=3d6d406b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6d406b",
  null
  
)

export default component.exports